export default __webpack_public_path__ + "2a4285847db4a9acb97fef9905c0ad44.ttf";